import classNames from 'classnames'

import { ICON_CHEVRON_DIRECTION } from '../../Icon'
import { NavArrowButton } from '../../NavArrow'
import { PdfViewerPageInput } from '../PdfViewerPageInput'

import * as styles from './PdfViewerNavigation.module.css'

function PdfViewerNavigation({
  activePage,
  arrowButtonProps,
  buttonClassName,
  handleChangePageInput,
  handleNextClick,
  handlePrevClick,
  leftButtonClassName,
  pageInputClassName = styles.inputPagination,
  pagesCount,
  rightButtonClassName,
}) {
  return (
    <>
      {activePage > 1 ? (
        <NavArrowButton
          {...arrowButtonProps}
          className={classNames(buttonClassName, leftButtonClassName)}
          direction={ICON_CHEVRON_DIRECTION.LEFT}
          onClick={handlePrevClick}
        />
      ) : null}
      {activePage < pagesCount ? (
        <NavArrowButton
          {...arrowButtonProps}
          className={classNames(buttonClassName, rightButtonClassName)}
          onClick={handleNextClick}
        />
      ) : null}
      {pagesCount > 1 ? (
        <PdfViewerPageInput
          activePage={activePage}
          className={pageInputClassName}
          totalPages={pagesCount}
          onChange={handleChangePageInput}
        />
      ) : null}
    </>
  )
}

export default PdfViewerNavigation
